import React, { useReducer, useEffect, useContext, useState } from "react";
import ReclamoContext from "./reclamoContext";
import TokenContext from "../Token/TokenContext";
import ParametrosContext from "../Parametros/ParametrosContext";
import reclamoReducer from "./reclamoReducer";
import moment from "moment";
import {
  GET_DATA_USER,
  SEND_RECLAMO,
  RECLAMO_ENVIADO,
  DATA_RECLAMO_ENVIADO,
  GET_ARCHIVOS,
  GET_PHONE_NUMBER,
  GET_TEMPORALES,
  ENVIANDO_DATA,
  PRIMERA_LLAMADA,
  EXISTENTE_ERROR
} from "../type";
import clienteAxios from "../../Utils/axios";

const { clean } = require("../../Utils/ValidateRut");

const ReclamoState = (props) => {
  const initialState = {
    data_usuario: [],
    reclamo: [],
    error: null,
    send: false,
    enviado: false,
    reclamo_enviado: [],
    archivos: [],
    phone_number: 0,
    reclamos_temporales: [],
    enviando_data: false,
    primera_llamada: false,
    existente_error: false
  };

  const [state, dispatch] = useReducer(reclamoReducer, initialState);

  const tokenContext = useContext(TokenContext);
  const { token, active_token } = tokenContext;

  const parametrosContext = useContext(ParametrosContext);
  const { parametros, comunas } = parametrosContext;

  const Get_Data_Change_F = (data_usuario) => {
    dispatch({
      type: GET_DATA_USER,
      payload: data_usuario,
    });
  };

  const Send_Reclamo_F = (send) => {
    dispatch({
      type: SEND_RECLAMO,
      payload: send,
    });
  };

  const Reclamo_Enviado_F = (enviado) => {
    dispatch({
      type: RECLAMO_ENVIADO,
      payload: enviado,
    });
  };

  const Data_Enviado_F = (enviado) => {
    dispatch({
      type: DATA_RECLAMO_ENVIADO,
      payload: enviado,
    });
  };

  const Get_Archivos_F = (archivos) => {
    dispatch({
      type: GET_ARCHIVOS,
      payload: archivos,
    });
  };

  const Get_Phone_F = (phone) => {
    dispatch({
      type: GET_PHONE_NUMBER,
      payload: phone,
    });
  };

  const Get_Temporales_F = (temporales) => {
    dispatch({
      type: GET_TEMPORALES,
      payload: temporales,
    });
  };

  const Enviado_F = (enviando) => {
    dispatch({
      type: ENVIANDO_DATA,
      payload: enviando,
    });
  };
  
  const SetPrimeraLlamada = (val) => {
    dispatch({
      type: PRIMERA_LLAMADA,
      payload: val,
    });
  };

  const SetShowExistente = (val) => {
    dispatch({
      type: EXISTENTE_ERROR,
      payload: val,
    });
  }

  const [ActivaTemporal, setActivaTemporal] = useState(false)

  useEffect(() => {
    const GetTemporales = async () => {
      try {
        let rut = atob(active_token);

        const dataForm = new FormData();
        dataForm.append("run", clean(rut.slice(0, -1)));
        dataForm.append("dv", rut.charAt(rut.length - 1));

        const res = await clienteAxios.post(
          `/ReclamoTemporal/?run=${clean(rut.slice(0, -1))}&dv=${rut.charAt(rut.length - 1)}`,
          dataForm,
          {
            headers: {
              Authorization: "Bearer " + token,
              accept: "application/json",
            },
          }
        );

        Get_Temporales_F(res.data);
        setActivaTemporal(false)
      } catch (error) {
        console.log(error);
      }
      SetPrimeraLlamada(true)
    };

    if (
      token !== null &&
      token !== "" &&
      token !== "undefined" &&
      token !== undefined &&
      active_token !== null &&
      active_token !== ""
    ) {
      if (state.reclamos_temporales.length === 0 || ActivaTemporal) {
        GetTemporales();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    const GetDataUser = async () => {
      try {
        let rut = atob(active_token);

        const dataForm = new FormData();
        dataForm.append("run", clean(rut.slice(0, -1)));
        dataForm.append("dv", rut.charAt(rut.length - 1));

        const res = await clienteAxios.post("/FichaCiudadano/", dataForm, {
          headers: {
            Authorization: "Bearer " + token,
            accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        });

        Get_Data_Change_F({
          ...state.data_usuario,
          run: res.data.arrfichaCiudadano.run,
          dv: res.data.arrfichaCiudadano.dv,
          nombres: res.data.arrfichaCiudadano.nombre,
          apellido_p: res.data.arrfichaCiudadano.apellido_p,
          apellido_m: res.data.arrfichaCiudadano.apellido_m,
          fecha_nacimiento: res.data.arrfichaCiudadano.fecha_nacimiento,
          sexo: res.data.arrfichaCiudadano.sexo.sexo_id,
          genero: res.data.arrfichaCiudadano.genero.genero_id,
          telefono_uno: res.data.arrfichaCiudadano.telefono_uno,
          isapre: "",
          email: res.data.arrfichaCiudadano.email,
          email2: "",
          region: res.data.arrfichaCiudadano.region.region_id,
          comuna: res.data.arrfichaCiudadano.comuna.comuna_id,
          direccion_via:
            res.data.arrfichaCiudadano.direccion_tipo.direccion_tipo_id,
          direccion_nombre: res.data.arrfichaCiudadano.direccion_nombre,
          direccion_nro: res.data.arrfichaCiudadano.direccion_nro,
          direccion_nro_dpto: res.data.arrfichaCiudadano.direccion_nro_dpto,
          nacionalidad: res.data.arrfichaCiudadano.nacionalidad.nacionalidad_id,
        });

        Get_Phone_F(res.data.arrfichaCiudadano.telefono_uno);
      } catch (error) {
        console.log(error);
      }
    };

    if (
      token !== null &&
      token !== "" &&
      token !== "undefined" &&
      token !== undefined &&
      active_token !== null &&
      active_token !== ""
    ) {
      if (state.data_usuario.length === 0) {
        GetDataUser();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    const SendData = async () => {
      try {
        let hoy = new Date();
        let edad = moment(hoy).diff(
          state.data_usuario.fecha_nacimiento,
          "years"
        );

        const sexoArray = parametros.sexo.find(
          (x) => x.id === Number(state.data_usuario.sexo)
        );
        const generoArray = parametros.genero.find(
          (x) => x.id === Number(state.data_usuario.genero)
        );
        const isapreArray = parametros.isapres.find(
          (x) => x.codigo_isapre === Number(state.data_usuario.isapre)
        );
        const regionArray = parametros.regiones.find(
          (x) => x.region_id === Number(state.data_usuario.region)
        );
        const comunaArray = comunas.find(
          (x) => x.comuna_id === Number(state.data_usuario.comuna)
        );
        const dviArray = parametros.tiposdireccion.find(
          (x) => x.id === Number(state.data_usuario.direccion_via)
        );

        const dataForm = new FormData();
        dataForm.append("run", state.data_usuario.run);
        dataForm.append("dv", state.data_usuario.dv);
        dataForm.append("nombre", state.data_usuario.nombres);
        dataForm.append("apellido_p", state.data_usuario.apellido_p);
        dataForm.append("apellido_m", state.data_usuario.apellido_m);
        dataForm.append("genero_id", generoArray.id);
        dataForm.append("genero_descripcion", generoArray.descripcion);
        dataForm.append(
          "fecha_nacimiento",
          state.data_usuario.fecha_nacimiento
        );
        dataForm.append("edad", edad);
        dataForm.append("codigo_isapre", isapreArray.codigo_isapre);
        dataForm.append("nombre_isapre", isapreArray.nombre_isapre);
        dataForm.append("telefono_uno", state.phone_number);
        dataForm.append("region_id", regionArray.region_id);
        dataForm.append("region_nombre", regionArray.region_nombre);
        dataForm.append("comuna_id", comunaArray.comuna_id);
        dataForm.append("comuna_nombre", comunaArray.comuna_nombre);
        dataForm.append("comuna_provincia_id", comunaArray.comuna_provincia_id);
        dataForm.append("direccion_tipo_id", dviArray.id);
        dataForm.append("dvi_descripcion", dviArray.descripcion);
        dataForm.append(
          "direccion_nombre",
          state.data_usuario.direccion_nombre
        );
        dataForm.append("direccion_nro", state.data_usuario.direccion_nro);
        dataForm.append(
          "direccion_nro_dpto",
          state.data_usuario.direccion_nro_dpto
        );
        dataForm.append("correo_uno", state.data_usuario.email);
        dataForm.append("v_correo_uno", state.data_usuario.email2);
        dataForm.append("sexo_id", sexoArray.id);
        dataForm.append("sexo_descripcion", sexoArray.descripcion);
        dataForm.append("nacionalidad_id", state.data_usuario.nacionalidad);

        for (var x = 0; x < state.archivos.length; x++) {
          dataForm.append(
            "file_" + x,
            state.archivos[x].file,
            state.archivos[x].name
          );
        }

        const res = await clienteAxios.post("/CreaReclamoTemporal/", dataForm, {
          headers: {
            Authorization: "Bearer " + token,
            accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        });

        Data_Enviado_F(res.data);
        Send_Reclamo_F(false);
        Reclamo_Enviado_F(true);
        Enviado_F(false);
        setActivaTemporal(true);
      } catch (error) {
        console.log(error);
        console.log(error.response.status);
        if(error.response.status === 409 ){
          SetShowExistente(!state.existente_error)
        }
        Enviado_F(false);
        Send_Reclamo_F(false);
        Reclamo_Enviado_F(false);
      }
    };

    if (state.send === true) {
      SendData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.send]);

  return (
    <ReclamoContext.Provider
      value={{
        data_usuario: state.data_usuario,
        reclamo: state.reclamo,
        enviado: state.enviado,
        reclamo_enviado: state.reclamo_enviado,
        archivos: state.archivos,
        phone_number: state.phone_number,
        reclamos_temporales: state.reclamos_temporales,
        enviando_data: state.enviando_data,
        primera_llamada: state.primera_llamada,
        existente_error: state.existente_error,
        Get_Data_Change_F,
        Send_Reclamo_F,
        Get_Archivos_F,
        Reclamo_Enviado_F,
        Get_Phone_F,
        Enviado_F,
        Get_Temporales_F,
      }}
    >
      {props.children}
    </ReclamoContext.Provider>
  );
};

export default ReclamoState;
